import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "./Style.css";
import useWindowSize from "../../utils/useWindowSize";
import { payoutregenratedData } from "./helper/payoutdatasample";
import PayoutManagmentListing from "./PayoutManagementListing/PayoutManagmentListing";
import { Button, Select, Modal, Table, message } from "antd";
import DopdownMenuWithMonth from "./DopdownMenuWithMonth";
import Logout from "../../containers/Pages/Login/Logout";
import PayoutManagmentListingChecker from "./PayoutManagementListingChecker/PayoutManagmentListingChecker";
import { connect } from "react-redux";
import { payoutListDataSuccess, submitReportForApprovalAction } from "../../redux/PayoutListByFY/Action";
import useSession from "../CustomLogout/useSession";
import RegenerationHistory from "./RegenerationHistory";
import { payoutRegenerateHistorySuccess } from "../../redux/PayoutRegenerateHistory/action";
import PayoutManagmentListingCPChecker from "./PayoutManagementListing/PayoutManagmentListingCPChecker";
import { Input } from "antd";

const PayoutManagementCPChecker = (props) => {
  const { width } = useWindowSize();
  const [regenerateData, setRegeneratedData] = useState([]);
  const [payoutListData, setPayoutListData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);
   const handleSessionExpired = useSession();
  const getCurrentFinancialYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  // Assuming FY starts in April
  return today.getMonth() >= 3
    ? { value: String(year), label: `${year}-${String(year + 1).slice(-2)}` }
    : { value: String(year - 1), label: `${year - 1}-${String(year).slice(-2)}` };
};
  // const [isModalOpen, setIsModalOpen] = useState(false);


  


  const generateFinancialYearOptions = (startYear = 2022) => {
  const today = new Date();
  const year = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  const options = [];
  for (let y = year; y >= startYear; y--) {
    options.push({
      value: String(y),
      label: `${y}-${String(y + 1).slice(-2)}`,
    });
  }
  return options;
};

  // Financial year state
    const [financialYear, setFinancialYear] = useState(getCurrentFinancialYear().value);

       // Pagination state
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 10,
      total: 0,
    });
  
  // Handler for pagination change
  const handleTableChange = (pagination) => {
    fetchRegenerateHistory(pagination.current, pagination.pageSize);
  };

  useEffect(() => {
    // Fetch payout list when component mounts or financial year changes  
    fetchPayoutList(financialYear);
    fetchRegenerateHistory(pagination.current, pagination.pageSize);
  }, [financialYear]);



  // Fetch payout list with pagination
    const fetchPayoutList = async (fy = financialYear) => {
      setDownloading(true);
      try {
        const payoutList = props.payoutListByFY({
          accessToken: props.accessToken,
          financialYear: fy,
          approvalstageId: "3", // Assuming 3 is the ID for "CP Checker" stage
        });
  
        const payoutListresponse = await payoutList;
        const errorCode = payoutListresponse?.response?.data?.error?.errorCode || payoutListresponse.errorCode;
          const errorMessage = payoutListresponse?.response?.data?.error?.message || payoutListresponse.message;
        if (errorCode === "403" && (payoutListresponse?.data?.error?.logoutStatus || payoutListresponse?.response?.data?.error?.logoutStatus)) {
            handleSessionExpired();
            return; // Stop further execution
          }
  
        setPayoutListData(payoutListresponse || []);
        // setPagination((prev) => ({
        //   ...prev,
        //   current: page,
        //   pageSize,
        //   total: payoutListresponse?.totalPages || 0,
        // }));
      } catch (error) {
        console.error("Error fetching payout list:", error);
      } finally {
        setDownloading(false);
      }
    };

    //fetch Regenerate history data
    const fetchRegenerateHistory = async (page = 1, pageSize = 10) => {
      try { 
        const regenerateHistory = props.payoutRegenerateHistory({
          accessToken: props.accessToken,
          financialYear: financialYear,
          approvalstageId: 3, // Assuming 3 is the ID for "CP Checker" stage
          page: page - 1, // backend might be 0-indexed
          record: pageSize,
          
        });
        const regenerateHistoryResponse = await regenerateHistory;
  
        const errorCode = regenerateHistory?.response?.data?.error?.errorCode || regenerateHistory.errorCode;
        const errorMessage = regenerateHistory?.response?.data?.error?.message || regenerateHistory.errorMessage;
        if (errorCode === "403" && (regenerateHistory?.data?.error?.logoutStatus || regenerateHistory?.response?.data?.error?.logoutStatus)) {
            handleSessionExpired();
            return; // Stop further execution
          }
        setRegeneratedData(regenerateHistoryResponse.content || []);
        setPagination((prev) => ({
          ...prev,
          current: page,
          pageSize,
          total: regenerateHistoryResponse?.totalElements || 0,
        }));
      } catch (error) {
        console.error("Error fetching regenerate history:", error);   
      } finally {
        setDownloading(false);
      }
    };  

  const handelSubmitForApproval = async (reportid) => {
    let remark = "";
    Modal.confirm({
      title: "Enter Remark For Approval",
      content: (
        <Input.TextArea
          placeholder="Please enter your remark"
          maxLength={250}
          showCount={true}
          onChange={e => {
            remark = e.target.value;
          }}
          autoSize={{ minRows: 3, maxRows: 5 }}
        />
      ),
      okText: "Submit",
      cancelText: "Cancel",
      okButtonProps: {
        style: { backgroundColor: "#1b8593", borderColor: "#1b8593" }
      },
      onOk: async () => {
        if (remark === "") {
          message.error("Remark is required.");
          return 0;
        }
        if (remark.length > 250) {
          message.error("Remark should not exceed 250 characters.");
          return 0;
        }
        try {
          const submitReport = props.submitReportForApproval({
            accessToken: props.accessToken,
            reportid: reportid,
            approvalStageId: 4,
            remarksComment: remark,
            remarkType: "Partner"
          });
          const submitReportResponse = await submitReport;
  
          const errorCode =
            submitReportResponse?.response?.data?.error?.errorCode ||
            submitReportResponse?.response?.status;
  
          if (
            errorCode === "403" &&
            (submitReportResponse?.response?.data?.error?.errorCode ||
              submitReportResponse?.response?.status)
          ) {
            handleSessionExpired();
            return;
          }
          if (!submitReportResponse || submitReportResponse.error) {
            message.error(
              submitReportResponse?.error || "Failed to submit report for approval"
            );
            return;
          }
          // Refresh payout list after submitting report
          fetchPayoutList( financialYear);
          // fetchMissingMonthsForGenReport();
          message.success("Report submitted for approval successfully.");
        } catch (error) {
          console.error("Error submitting report for approval:", error);
          message.error("Error submitting report for approval.");
        }
      },
    });
  };

// const handelSubmitForApproval = async (reportid) => {
//   console.log("Submit for Approval Clicked for Report ID:", reportid);

//   let remark = "";
//   Modal.confirm({
//     title: "Enter Remark For Approval",
//     content: (
//       <Input.TextArea
//         placeholder="Please enter your remark"
//         onChange={e => {
//           remark = e.target.value;
//         }}
//         autoSize={{ minRows: 3, maxRows: 5 }}
//       />
//     ),
//     okText: "Submit",
//     cancelText: "Cancel",
//     okButtonProps: {
//       style: { backgroundColor: "#1b8593", borderColor: "#1b8593" }
//     },
//     onOk: async () => {
//       if (!remark.trim()) {
//         message.error("Remark is required.");
//         return Promise.reject();
//       }
//       try {
//         const submitReport = props.submitReportForApproval({
//           accessToken: props.accessToken,
//           reportid: reportid,
//           approvalStageId: 4, // Updated as requested
//           remarksComment: remark,
//           remarkType: "Partner"
//         });
//         const submitReportResponse = await submitReport;
//         const errorCode = submitReportResponse?.response?.data?.error?.errorCode || submitReportResponse?.response?.status;

//         if (errorCode === "403" && (submitReportResponse?.response?.data?.error?.errorCode || submitReportResponse?.response?.status)) {
//           console.log("Session expired, redirecting to login...");
//           handleSessionExpired();
//           return;
//         }
//         if (!submitReportResponse || submitReportResponse.error) {
//           throw new Error(submitReportResponse?.error || "Failed to submit report for approval");
//         }
//         // Refresh payout list after submitting report
//         fetchPayoutList(financialYear);
//         // fetchMissingMonthsForGenReport();
//         message.success("Report submitted for approval successfully.");
//       } catch (error) {
//         console.error("Error submitting report for approval:", error);
//         message.error("Error submitting report for approval.");
//       }
//     },
//   });
// };


  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };
  
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleRegenerateHistory = () =>{
  // setRegeneratedData(payoutregenratedData);
  setIsModalOpen(true);

 
 }

  return (
    <div style={{ maxWidth: "100%" }}>
     <Row>
             <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
               <Col md={8} className="search-bar"></Col>
               <Col md={4}>
                  <div className="login-profie">
                               <div className="img-sec">
                                 <h2>
                                   {adminFirstName(
                                             props.userDetail?.firstName ??
                                             props.userDetail?.userName?.split(" ")[0]?.trim()
                                           )}
                                   
                                 </h2>
                                 <h2>
                                   {adminLastName(
                                             props.userDetail?.lastName ??
                                             props.userDetail?.userName?.split(" ")[1]?.trim()
                                           )}
                                 </h2>
                               </div>
                 
                               <div className="content-login">
                                 <h4>{props.userDetail?.userName}</h4>
                                         <h5>{props.userDetail?.roleName}</h5>
                                
                                 <div className="content-login-data">
                                   {/* <ChangePassword /> */}
                                   <div className="admin-small-space"> </div>
                                  
                                   <Logout />
                                   {/* <h6>Change Password | Logout</h6> */}
                                 </div>
                               </div>
                 </div>
               </Col>
             </Col>
           </Row>

      {/* <Row>
        <div style={{ display: "flex" }}>
          <Col lg={12} xs={12} md={12} sm={12}>
            <Col
              md={6}
              style={{ display: "flex", margin: 10 }}
              className="btn-partner"
            >
              <div>

                  <Select style={{ width: 150, }}
                      showSearch
                      placeholder="Select finacial Year"
                      optionFilterProp="label"
                      // onChange={onChange}
                      // onSearch={onSearch}
                      defaultValue={"2024-25"}
                      options={[
                        {
                          value: '2024-25',
                          label: '2024-25',
                        },
                        {
                          value: '2023-24',
                          label: '2023-24',
                        },
                        {
                          value: '2022-23',
                          label: '2022-23',
                        },
                      ]}
                    />
              </div>
            </Col>
          </Col>
        </div>
      </Row> */}

      <Row style={{ display: "flex", marginTop: 100, marginBottom: 10 }}>
          <Col md={3}>
            <div>
                            <Select
                              style={{ width: 150, 
                               marginTop: width < 750 ? 70 : 10, 
                              }}
                              showSearch
                              placeholder="Select financial Year"
                              optionFilterProp="label"
                              value={financialYear}
                              onChange={(value) => setFinancialYear(value)}
                              options={generateFinancialYearOptions(2022)}
                              // handelSubmit={handelSubmitForApproval}
                            />
                          </div>
          </Col>
          <Col md={9} style={{display: "flex",
              justifyItems: "end",
              alignItems: "end",
              justifyContent: "end",}}   className="btn-partner">
                {/* <DopdownMenuWithMonth
                lastGeneratedMonths={["January", "February"]}
                name={"Generate Report"}
                />

                <DopdownMenuWithMonth
                lastGeneratedMonths={["January", "March", "April"]}
                name={"Regenerate Report"}
                /> */}
      
              <Button
                className="ant-btn ant-btn-default reset-btn"
                type="primary"
                style={{ width: 180,margin:5, fontSize:"0.8rem", justifyContent:"center", overflow:"hidden",padding:5, marginBottom:10}}
                onClick={() => handleRegenerateHistory()}
              >
                Regeneration History
              </Button>
          </Col>
          
          </Row>
      

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <PayoutManagmentListingCPChecker
            dataSource = {payoutListData}
            //  onChange={handleTableChange}
            loading={downloading}
            handelSubmit={handelSubmitForApproval}
          />
        </Col>
      </Row>
      
      <RegenerationHistory
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        regenerateData={regenerateData}
        setRegeneratedData={setRegeneratedData}
        onChange = {handleTableChange}
        pagination={pagination}
        setPagination={setPagination}
      />
     
        {/* <Modal title=" " centered width={1000} open={isModalOpen} style={{width:"auto"}} maskStyle={{  backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onOk={handleOk} onCancel={handleCancel}>
        <Table  dataSource={regenerateData} style={{maxHeight:"60vh", overflow:"auto"}}  columns={columnsData} pagination={false} scroll={{ x:"max-content" }} />
        </Modal> */}
      {/* 
        <div>PayoutManagement</div> */}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    payoutListByFY: (data) => dispatch(payoutListDataSuccess(data)),
    payoutRegenerateHistory: (data) => dispatch(payoutRegenerateHistorySuccess(data)),
    submitReportForApproval: (data) => dispatch(submitReportForApprovalAction(data)),
  };
}

const mapStateToProps = (state) => {
  return {
  
   
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
      payoutListDataSuccess: state.payoutListByFY.payoutListByFY,
    payoutRegenerateHistorySuccess: state.payoutRegenerateHistory.payoutRegenerateHistory,
  };
}

export default connect(mapStateToProps,mapDispatchToProps) (PayoutManagementCPChecker);
